import moment from 'moment'

const getActivityPervent = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return 0
  }
  const now = moment()
  const start = moment(startDate)
  const end = moment(endDate)

  if (now.isSameOrBefore(start)) {
    return 0
  }
  if (now.isSameOrAfter(end)) {
    return 100
  }

  const totalDuration = end.diff(start)
  const elapsed = now.diff(start)

  const percent = (elapsed / totalDuration) * 100

  return Math.min(100, Math.max(0, Math.round(percent)))
}

export { getActivityPervent }
